import { Spin } from 'antd';
import styled from 'styled-components';

export const Spinner = styled(Spin)`
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.7);
`;

export const Wrapper = styled.div`
  position: relative;
  background: #ffffff;
  padding: 0 0 1rem 0;
  border-radius: 12px;
  box-shadow: 0px 4px 9px 0px #161a1d0d;
`;
